import { SidebarInset, SidebarProvider } from '@/shared/ui/shadcn/ui/sidebar';
import { AppSidebar } from '@/widgets/app-sidebar';
import { AppNavbar } from '@/widgets/app-navbar';
import { FC } from 'react';
import { Outlet } from 'react-router';
import { AuthProvider } from '../providers/authProvider/AuthProvider';

export const MainLayout: FC = () => {
  return (
    <AuthProvider>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="bg-grey-f3f4f6">
          <AppNavbar />
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </AuthProvider>
  );
};
